import React, { useState } from "react";
import { User, UserCircle, X } from "lucide-react";
import { useAtom } from "jotai";
import {
    activeChildDetail,
    childList,
    appConstants,
    childSelectAtom
} from "../../atomstore/store";

const ChildSelectModal = () => {
    const [constants] = useAtom(appConstants);
    const [children] = useAtom(childList);
    const [activeChild, setActiveChild] = useAtom(activeChildDetail);
    const [isOpen, setIsOpen] = useAtom(childSelectAtom);
    const [imageError, setImageError] = useState(false);

    if (!isOpen || !children?.length) return null;

    const getFullPath = (constants, path) => {
        if (typeof path === "string" && path.startsWith("https")) return path;
        if (typeof path === "string" && path.length === 0) return path;
        return constants?.ImagePath + path;
    };

    const handleSelect = (child) => {
        setActiveChild(child);
        setIsOpen(false);
    };

    return (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-[9999] flex items-center justify-center p-4">
            <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-6 relative">

                {/* Close Button */}
                <button
                    onClick={() => setIsOpen(false)}
                    className="absolute top-3 right-3 p-2 rounded-full hover:bg-gray-100 transition"
                >
                    <X className="w-5 h-5 text-gray-500" />
                </button>

                <h2 className="text-xl font-semibold text-gray-800 mb-6 text-center">
                    Select Your Child
                </h2>

                {/* Children Grid */}
                <div className="grid grid-cols-2 gap-4">
                    {children.map((child) => {
                        const isActive = activeChild?.id === child.id;

                        return (
                            <div
                                key={child.id}
                                onClick={() => handleSelect(child)}
                                className={`cursor-pointer bg-white rounded-2xl p-4 shadow-sm border transition 
                ${isActive ? "border-cyan-500 shadow-md" : "border-gray-100"}`}
                            >
                                <div className="flex flex-col items-center">

                                    {/* Image Container (Matching MyChildren.js) */}
                                    <div
                                        className={`w-20 h-20 rounded-xl bg-gradient-to-br from-cyan-100 to-blue-100 flex items-center justify-center overflow-hidden border-[4px]
                    ${isActive ? "border-cyan-500" : "border-transparent"}
                  `}
                                    >
                                        {
                                            child?.child_photo &&
                                                child?.child_approved_status !== "Inactive" &&
                                                !imageError ? (
                                                <img
                                                    className="w-full h-full object-cover"
                                                    src={getFullPath(constants, child.child_photo)}
                                                    alt={child?.name}
                                                    onError={() => setImageError(true)}
                                                />
                                            ) : (
                                                <div className="w-full h-full
                        rounded-full flex items-center justify-center text-gray-600 font-bold text-lg">
                                                    <UserCircle size={50} />
                                                </div>
                                            )
                                        }
                                    </div>

                                    {/* Name */}
                                    <p className="mt-3 font-semibold text-gray-800 text-center">
                                        {child.name} {child.last_name}
                                    </p>

                                    {isActive && (
                                        <p className="text-xs text-cyan-700 mt-1 font-medium">Active</p>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>

            </div>
        </div>
    );
};

export default ChildSelectModal;
